import * as Sentry from '@sentry/react';
import { ComponentType, Suspense, lazy } from 'react';
import AuthGuard from './AuthGuard';
import errorFallback from '@/components/ErrorFallback';

export default function PageWrapper<T extends Record<string, unknown>>(
  loader: () => Promise<{ default: ComponentType<T> }>,
  Skeleton: ComponentType,
) {
  return lazy(() =>
    loader().then((module) => ({
      default: (props: T) => {
        return (
          <Sentry.ErrorBoundary
            fallback={({ eventId, resetError }) =>
              errorFallback('PageWrapper', eventId, resetError)
            }
          >
            <Suspense fallback={<Skeleton />}>
              <AuthGuard>
                <module.default {...props} />
              </AuthGuard>
            </Suspense>
          </Sentry.ErrorBoundary>
        );
      },
    })),
  );
}
